import React, {useEffect, useRef, useState} from "react";
import {Box, Button, CircularProgress, styled} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import CircularStatic from "../Npi/NpiCircularProgressWithLabel";
import LinearWithValueLabel from "../utils/LinearProgressWithLabel";
import {printTime} from "../utils/cert-helper";
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from "@mui/material/Backdrop";
import {cancelBatchProgress, getActiveBatchProgressById} from "../ExternalSourceManagement/ExternalSourceBatchProcess";
import {cancelBatch, update} from "../features/allBatchesSlice";
import {splitPath} from "../ExternalSourceManagement/ExternalSourceTable";

const StyledDiv = styled('div')({
    paddingTop: 5,
    display: 'block',
    position: 'relative',
    width: '100%', margin: 'auto'
})
const StyledButton = styled(Button)({
    float: 'right', marginRight: 6, marginTop: 10,
    '& .MuiSvgIcon-root': {marginRight: 3}
})
const BatchStatus = {
    Init: 'Init',
    Running: 'Running',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Interrupted: 'Interrupted'
}


export default function NuccSpecialtyValueSetBatchProcessBar(props) {
    const account = useSelector(state => state.userAccount.userAccount);
    const {id, progress, status, createdTs, dataPath} = props.batch
    const dispatch = useDispatch();
    const statusRef = useRef();

    const [loading, setLoading] = useState(false);
    // const {taxonomyBatchId, taxonomyProgress, taxonomyStatus, taxonomyCreatedTs, taxonomyDataPath} = useSelector(state => state.taxonomyBatch);
    // const {progress, status, createdTs, dataPath} = useSelector(state => state.taxonomyBatchProcess);


    // const handleImportCompleted = () => {
    //     dispatch(getAllBatches());
    //     window.setTimeout(() => {
    //         window.location.href = PortalUrl.ExternalSource.NUCCSpecialty.pattern_home;
    //         dispatch(resetTaxonomyBatch());
    //     }, 900)
    // }

    useEffect(() => {
        const timer = setInterval(() => {
            if (account) {
                if (statusRef.current !== BatchStatus.Completed && statusRef.current !== BatchStatus.Cancelled && statusRef.current !== BatchStatus.Failed) {
                    // getTaxonomyBatchProcessById(taxonomyBatchId);
                    getActiveBatchProgressById(id)
                        .then(res => {
                            // dispatch(addTaxonomyBatch(res));
                            dispatch(update({'type': 'nucc', 'id': res.id, 'batch': res}));
                        })
                }
            }
        }, 750)
        return () => {
            clearInterval(timer);
        }
    }, [])

    useEffect(() => {
        statusRef.current = status;
    }, [progress])

    // useEffect(() => {
    //     if (statusRef.current === BatchStatus.Completed) {
    //         handleImportCompleted();
    //     }
    // }, [statusRef.current])


    const handleCancel = () => {
        cancelBatchProgress(id, account, setLoading)
            .then( res => {
                console.log(res);
                // dispatch(resetTaxonomyBatch());
                dispatch(cancelBatch({ type: 'nucc', 'id': id}));
            })
    }


    return (
        <StyledDiv>
            <div>
                <CircularStatic progress={progress}/>
                <StyledButton size='small' onClick={handleCancel} startIcon={<CancelIcon />}>
                    Cancel The Progress</StyledButton>
                <Box sx={{width: '100%'}}>
                    <LinearWithValueLabel progress={progress}/>
                </Box>
                <strong>Currently processing Specialty Value Sets File Task: </strong>
                <br/>
                <strong>Individual URL: </strong>
                {splitPath(dataPath)[0]}
                <br/>
                <strong>Non-Individual URL: </strong>
                {splitPath(dataPath)[1]}
                <br/>
                <strong>Started since </strong>
                {printTime(createdTs)}
            </div>
            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={loading}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledDiv>

    )
}